import React from 'react'
import OnlyNumberInput from './OnlyNumberInput'

import OnlySlider from './OnlySlider'

function LoopSliderBox({ min, max, value, onChange, style }) {
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '0.75rem',
                padding: '1rem 2rem',
                boxSizing: 'border-box',
                width: '100%',
                fontFamily: 'Halcyon_SemiBold',
                fontSize: '1.25rem',
                color: 'black',
                ...style,
            }}
        >
            <span>Repeat</span>
            <OnlySlider min={min} max={max} value={value} onChange={onChange} />
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    gap: '0.5rem',
                }}
            >
                <OnlyNumberInput
                    min={min}
                    max={max}
                    value={value}
                    onChange={onChange}
                />
                <span>times</span>
            </div>
        </div>
    )
}

export default LoopSliderBox
